import styled from 'styled-components';

export const Caption = styled.div`
  font-size: 9px;
  line-height: 17px;
  color: var(--text-color-secondary);
`;
